import { ReactNode } from "react";
import { Icon, Tooltip } from "@chakra-ui/react";
import { MdLock } from "react-icons/md";

type UnavailableTooltipProps = {
  children: ReactNode;
  isUnavailable?: boolean;
};

export function UnavailableTooltip({
  children,
  isUnavailable,
}: UnavailableTooltipProps) {
  if (!isUnavailable) return children;

  return (
    <Tooltip
      label="This feature is not included in your subscription."
      placement="right"
      openDelay={750}
      hasArrow
    >
      {children}
    </Tooltip>
  );
}

export function UnavailableIcon() {
  return (
    <Icon as={MdLock} ml={2} mt="-.15em" opacity={0.7} verticalAlign="middle" />
  );
}
